<template>
    <div class="row w-100">
        <div class="col-auto text-center flex-column d-none d-flex pl-0">
            <div class="row h-50">
                <div class="col" :class="{'border-right':!first}">&nbsp;</div>
                <div class="col">&nbsp;</div>
            </div>
            <h5 class="m-2">
                <span class="badge badge-pill " :class="[themeColor.dot]" style="-webkit-text-fill-color: transparent;"> . </span>
            </h5>
            <div class="row h-50">
                <div class="col" :class="{'border-right':!last}">&nbsp;</div>
                <div class="col">&nbsp;</div>
            </div>
        </div>
        <div class="col py-2" style="padding-left:0">
            <div class="card" :class="[themeColor.border]">
                <div class="card-body">
                    <div class="float-right" :class="[themeColor.text]">{{this.date}}</div>
                    <h4 class="card-title" :class="[themeColor.text]">{{this.title}}</h4>
                    <p class="card-text">{{this.content}}</p>
                </div>
            </div>
        </div>
    </div>
    <!-- <b-row>
        <b-col class="col-auto text-center flex-column d-none d-sm-flex">
            <b-row class="h-50">
                <b-col class="border-right">&nbsp;</b-col>
                <b-col>&nbsp;</b-col>
            </b-row>
            <h5 class="m-2">
                <span class="badge badge-pill bg-light border">&nbsp;</span>
            </h5>
            <b-row>
                <b-col class="border-right">&nbsp;</b-col>
                <b-col>&nbsp;</b-col>
            </b-row>
        </b-col>
        <div class="col py-2">
            <div class="card">
                <div class="card-body">
                    <div class="float-right text-muted">{{this.date}}</div>
                    <h4 class="card-title text-muted">{{this.title}}</h4>
                    <p class="card-text">{{this.content}}</p>
                </div>
            </div>
        </div>
    </b-row> -->
</template>

<script>
export default {
    name:'Timeline',
    props:['date','title','content','variant','first','last'],
    computed:{
        themeColor(){
            switch (this.variant) {
                case 'light':
                    return {
                        dot:"bg-light",
                        text:"text-muted",
                        border:""
                    }

                case 'primary':
                    return {
                        dot:"bg-primary",
                        text:"text-primary",
                        border:"border-primary"
                    }
  
                case 'success':
                    return {
                        dot:"bg-success",
                        text:"text-success",
                        border:"border-success"
                    }                    
 
                case 'warning':
                    return {
                        dot:"bg-warning",
                        text:"text-warning",
                        border:"border-warning"
                    }                    

                case 'danger':
                    return {
                        dot:"bg-danger",
                        text:"text-danger",
                        border:"border-danger"
                    }
  
                default:
                    return {
                        dot:"bg-light",
                        text:"text-muted",
                        border:""
                    }

            }
        }
    }
}
</script>

<style>

</style>